interface ItemType {
  DEFAULT: number;
  GENERIC: number;
}

export const ITEM_TYPE: ItemType = { DEFAULT: 1, GENERIC: 2 };
